// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import constants from "@store/constants";
import OrderChangeRequestOrderLine from "@store/Library/Components/OrderChangeRequest/OrderChangeRequestOrderLine";
import { OrderLinesListStyles } from "@store/Overrides/Components/OrderLinesList";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    showLineNumber = "showLineNumber",
    listTitle = "listTitle",
    listSubtitle = "listSubtitle",
    changeRequestReasons = "changeRequestReasons",
}

const mapStateToProps = (state: ApplicationState) => ({
    order: getOrderState(state, state.pages.orderDetails.orderNumber),
});

export type OrderRequestReasonModel = {
    fields: {
        reason: string;
    };
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> & {
        [fields.showLineNumber]: boolean;
        [fields.changeRequestReasons]: OrderRequestReasonModel[];
    };

export interface OrderChangeRequestDetailSummaryTableStyles {
    orderLines?: OrderLinesListStyles;
}

const OrderChangeRequestDetailsSummaryTable: React.FunctionComponent<Props> = ({
    order,
    fields: { showLineNumber, changeRequestReasons, listTitle, listSubtitle },
}) => {
    if (!order.value || !order.value.orderLines) {
        return null;
    }

    return (
        <>
            <StyledWrapper>
                <Typography variant="h4" as="h4">
                    {
                        // eslint-disable-next-line spire/avoid-dynamic-translate
                        translate(listTitle)
                    }
                </Typography>
                {listSubtitle && (
                    <Typography variant="p">
                        {
                            // eslint-disable-next-line spire/avoid-dynamic-translate
                            translate(listSubtitle)
                        }
                    </Typography>
                )}
            </StyledWrapper>
            <OrderChangeRequestOrderLine
                order={order.value}
                showLineNumber={showLineNumber}
                changeRequestReasons={changeRequestReasons}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderChangeRequestDetailsSummaryTable),
    definition: {
        allowedContexts: ["OrderChangeRequestPage" as any],
        group: constants.widgetGroup.orderChangeRequest,
        fieldDefinitions: [
            {
                name: fields.showLineNumber,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                variant: "toggle",
            },
            {
                name: fields.listTitle,
                editorTemplate: "TextField",
                defaultValue: "Edit or Remove items in your order",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.listSubtitle,
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.changeRequestReasons,
                editorTemplate: "ListField",
                getDisplay: item => item.fields.reason,
                defaultValue: [],
                fieldType: "Translatable", // Starter Custom Code
                fieldDefinitions: [
                    {
                        name: "reason",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
